import { render, staticRenderFns } from "./multi-picture.vue?vue&type=template&id=303fac04&scoped=true&"
import script from "./multi-picture.vue?vue&type=script&lang=ts&"
export * from "./multi-picture.vue?vue&type=script&lang=ts&"
import style0 from "./multi-picture.vue?vue&type=style&index=0&id=303fac04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303fac04",
  null
  
)

component.options.__file = "multi-picture.vue"
export default component.exports